import configs from 'configs';
import { GA_EVENT_TYPE } from 'define';
import { get } from 'lodash';
import ReactGA from 'react-ga4';

const { shopId, gaCategory } = configs;

export const GaEventType = GA_EVENT_TYPE;

// export const sendGaEvent = (lineId, eventType, action) => {
//     if (!lineId || !action || !eventType) return;

//     const type = eventType.toLowerCase();
//     ReactGA.set({
//         userId: `shop/${ShopId}/user/${lineId}`,
//         referrer: `https://linebot/shop/${ShopId}/user/${lineId}`,
//         title: `${type} ${action}`
//     });
//     const event = {
//         category: `${type}/${ShopId}`,
//         action,
//         label: `shop/${ShopId}/customer/${lineId}`,
//         value: 1
//     };
//     ReactGA.event(event);
//     console.log('sendGaEvent', event);
// };

export const sendGaEvent = (lineId, action, others = {}) => {
    if (!lineId || !action) return;

    const event = {
        ...others,
        userId: `shop/${shopId}/user/${lineId}`,
        referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
        title: action,
        category: `${gaCategory}/${shopId}`,
        action,
        label: `shop/${shopId}/customer/${lineId}${get(others, '_label', '')}`,
        value: 1
    };

    console.log(`ga event [${action}]`, event);

    ReactGA.event({ ...event, shopId, lineId });
};

export const sendGaView = (lineId, ga) => {
    if (!lineId || !ga) return;
    const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
    const pageviewEvent = {
        hitType: 'pageview',
        page,
        userId: `shop/${shopId}/user/${lineId}`,
        referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
        location: window.location.href || '',
        title: ga
    };
    console.log(`ga pageview [${ga}]`, pageviewEvent);
    ReactGA.send(pageviewEvent);
};
